module.exports = __webpack_public_path__ + "img/xzrz.023c236f.png";